export const PALETTE = [
  ["#ffe1e8", "#ff3d6e", "#8e0c34"],
  ["#dcefff", "#3d8bff", "#112a80"],
  ["#d8ffec", "#1fc98a", "#05583f"],
  ["#fff4c8", "#f5b335", "#8a4f00"],
  ["#f2e1ff", "#a35bff", "#3f1286"],
  ["#ffe6d6", "#ff8a4c", "#93300c"],
];
export const NAMES = ["Rosenherz", "Saphirtropfen", "Smaragd", "Goldperle", "Amethyststern", "Pfirsich-Macaron"];

function shape(ctx, c, cx, cy, r) {
  ctx.beginPath();
  if (c === 0) {
    const t = cy - r * 0.42;
    ctx.moveTo(cx, cy + r * 0.92);
    ctx.bezierCurveTo(cx - r * 1.25, cy + r * 0.05, cx - r * 0.98, t - r * 0.62, cx - r * 0.46, t - r * 0.5);
    ctx.bezierCurveTo(cx - r * 0.18, t - r * 0.44, cx, t - r * 0.2, cx, t + r * 0.05);
    ctx.bezierCurveTo(cx, t - r * 0.2, cx + r * 0.18, t - r * 0.44, cx + r * 0.46, t - r * 0.5);
    ctx.bezierCurveTo(cx + r * 0.98, t - r * 0.62, cx + r * 1.25, cy + r * 0.05, cx, cy + r * 0.92);
  } else if (c === 1) {
    ctx.moveTo(cx, cy - r * 1.0);
    ctx.bezierCurveTo(cx + r * 0.25, cy - r * 0.55, cx + r * 0.9, cy - r * 0.05, cx + r * 0.9, cy + r * 0.3);
    ctx.arc(cx, cy + r * 0.3, r * 0.9, 0, Math.PI, false);
    ctx.bezierCurveTo(cx - r * 0.9, cy - r * 0.05, cx - r * 0.25, cy - r * 0.55, cx, cy - r * 1.0);
  } else if (c === 2) {
    const pts = [[-0.55, -0.85], [0.55, -0.85], [0.98, -0.28], [0, 0.98], [-0.98, -0.28]];
    pts.forEach(([px, py], i) => (i ? ctx.lineTo : ctx.moveTo).call(ctx, cx + px * r, cy + py * r));
  } else if (c === 3) {
    ctx.arc(cx, cy, r * 0.9, 0, Math.PI * 2);
  } else if (c === 4) {
    for (let i = 0; i < 10; i++) {
      const a = -Math.PI / 2 + (i * Math.PI) / 5, rr = i % 2 ? r * 0.5 : r * 1.0;
      (i ? ctx.lineTo : ctx.moveTo).call(ctx, cx + Math.cos(a) * rr, cy + Math.sin(a) * rr + r * 0.06);
    }
  } else {
    const w = r * 0.86, k = r * 0.42;
    ctx.moveTo(cx - w + k, cy - w); ctx.arcTo(cx + w, cy - w, cx + w, cy + w, k); ctx.arcTo(cx + w, cy + w, cx - w, cy + w, k);
    ctx.arcTo(cx - w, cy + w, cx - w, cy - w, k); ctx.arcTo(cx - w, cy - w, cx + w, cy - w, k);
  }
  ctx.closePath();
}

function body(ctx, c, cx, cy, r, pal) {
  const [l, m, d] = pal;
  ctx.save();
  ctx.shadowColor = "rgba(0,0,0,.45)"; ctx.shadowBlur = r * 0.35; ctx.shadowOffsetY = r * 0.14;
  shape(ctx, c, cx, cy, r);
  ctx.fillStyle = d; ctx.fill();
  ctx.restore();
  const g = ctx.createRadialGradient(cx - r * 0.35, cy - r * 0.45, r * 0.05, cx, cy, r * 1.35);
  g.addColorStop(0, l); g.addColorStop(0.32, m); g.addColorStop(1, d);
  shape(ctx, c, cx, cy, r); ctx.fillStyle = g; ctx.fill();
  ctx.save(); shape(ctx, c, cx, cy, r); ctx.clip();
  const rim = ctx.createRadialGradient(cx + r * 0.3, cy + r * 0.55, 0, cx + r * 0.3, cy + r * 0.55, r * 0.9);
  rim.addColorStop(0, "rgba(255,255,255,.28)"); rim.addColorStop(1, "rgba(255,255,255,0)");
  ctx.fillStyle = rim; ctx.fillRect(cx - r * 1.5, cy - r * 1.5, r * 3, r * 3);
  if (c === 2) {
    ctx.strokeStyle = "rgba(255,255,255,.35)"; ctx.lineWidth = Math.max(1, r * 0.05);
    ctx.beginPath(); ctx.moveTo(cx - r * 0.98, cy - r * 0.28); ctx.lineTo(cx + r * 0.98, cy - r * 0.28);
    ctx.moveTo(cx - r * 0.3, cy - r * 0.85); ctx.lineTo(cx - r * 0.45, cy - r * 0.28); ctx.lineTo(cx, cy + r * 0.98); ctx.lineTo(cx + r * 0.45, cy - r * 0.28); ctx.lineTo(cx + r * 0.3, cy - r * 0.85); ctx.stroke();
  }
  if (c === 5) {
    ctx.fillStyle = "rgba(255,255,255,.22)"; ctx.fillRect(cx - r, cy - r * 0.08, r * 2, r * 0.16);
  }
  ctx.restore();
  shape(ctx, c, cx, cy, r); ctx.lineWidth = Math.max(1, r * 0.06); ctx.strokeStyle = "rgba(0,0,0,.18)"; ctx.stroke();
}

function shine(ctx, cx, cy, r) {
  const g = ctx.createRadialGradient(cx - r * 0.32, cy - r * 0.48, 0, cx - r * 0.32, cy - r * 0.48, r * 0.55);
  g.addColorStop(0, "rgba(255,255,255,.95)"); g.addColorStop(0.45, "rgba(255,255,255,.35)"); g.addColorStop(1, "rgba(255,255,255,0)");
  ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(cx - r * 0.3, cy - r * 0.45, r * 0.42, r * 0.26, -0.5, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = "rgba(255,255,255,.9)"; ctx.beginPath(); ctx.arc(cx + r * 0.38, cy - r * 0.18, r * 0.06, 0, Math.PI * 2); ctx.fill();
}

function bomb(ctx, cx, cy, r) {
  ctx.save(); ctx.shadowColor = "rgba(0,0,0,.5)"; ctx.shadowBlur = r * 0.4; ctx.shadowOffsetY = r * 0.15;
  ctx.beginPath(); ctx.arc(cx, cy, r * 0.95, 0, Math.PI * 2); ctx.fillStyle = "#1e0b05"; ctx.fill(); ctx.restore();
  const g = ctx.createRadialGradient(cx - r * 0.35, cy - r * 0.4, r * 0.05, cx, cy, r * 1.2);
  g.addColorStop(0, "#b07a5a"); g.addColorStop(0.35, "#5a2e1d"); g.addColorStop(1, "#1a0904");
  ctx.beginPath(); ctx.arc(cx, cy, r * 0.95, 0, Math.PI * 2); ctx.fillStyle = g; ctx.fill();
  for (let i = 0; i < 16; i++) {
    const a = i * 2.39996, d = r * (0.25 + ((i * 37) % 10) / 16);
    const x = cx + Math.cos(a) * d, y = cy + Math.sin(a) * d;
    ctx.save(); ctx.translate(x, y); ctx.rotate(a * 1.7);
    ctx.fillStyle = PALETTE[i % 6][1]; ctx.beginPath(); ctx.roundRect(-r * 0.12, -r * 0.04, r * 0.24, r * 0.08, r * 0.04); ctx.fill(); ctx.restore();
  }
  ctx.strokeStyle = "rgba(255,215,150,.55)"; ctx.lineWidth = r * 0.05; ctx.beginPath(); ctx.arc(cx, cy, r * 0.95, 0, Math.PI * 2); ctx.stroke();
}

const cache = new Map();

export function sprite(c, sp, px) {
  const k = `${c}|${sp || ""}|${px}`;
  if (cache.has(k)) return cache.get(k);
  const cv = document.createElement("canvas");
  cv.width = cv.height = px;
  const ctx = cv.getContext("2d");
  const cx = px / 2, cy = px / 2, r = px * 0.36;
  if (sp === "b") { bomb(ctx, cx, cy, r); shine(ctx, cx, cy, r); cache.set(k, cv); return cv; }
  const pal = PALETTE[c];
  if (sp === "w") {
    ctx.save(); ctx.shadowColor = "rgba(255,200,90,.8)"; ctx.shadowBlur = r * 0.6;
    const gg = ctx.createLinearGradient(cx - r, cy - r, cx + r, cy + r);
    gg.addColorStop(0, "#fff1b8"); gg.addColorStop(0.5, "#e8a930"); gg.addColorStop(1, "#8a5a00");
    ctx.fillStyle = gg; ctx.beginPath(); ctx.roundRect(cx - r * 1.08, cy - r * 1.08, r * 2.16, r * 2.16, r * 0.55); ctx.fill(); ctx.restore();
    ctx.fillStyle = "rgba(40,10,25,.55)"; ctx.beginPath(); ctx.roundRect(cx - r * 0.92, cy - r * 0.92, r * 1.84, r * 1.84, r * 0.45); ctx.fill();
    body(ctx, c, cx, cy, r * 0.78, pal); shine(ctx, cx, cy, r * 0.78);
  } else {
    body(ctx, c, cx, cy, r, pal);
    if (sp === "h" || sp === "v") {
      ctx.save(); shape(ctx, c, cx, cy, r); ctx.clip();
      ctx.fillStyle = "rgba(255,255,255,.62)";
      for (let i = -3; i <= 3; i += 2) {
        if (sp === "h") ctx.fillRect(cx - r * 1.2, cy + i * r * 0.18 - r * 0.07, r * 2.4, r * 0.14);
        else ctx.fillRect(cx + i * r * 0.18 - r * 0.07, cy - r * 1.2, r * 0.14, r * 2.4);
      }
      ctx.restore();
    }
    shine(ctx, cx, cy, r);
  }
  cache.set(k, cv);
  return cv;
}

export const spriteUrl = (c, sp, px = 96) => sprite(c, sp, px).toDataURL();
